// Hub unificado de Reportes Contables — Resumen + KPIs + Balance + ER + Mayor + Diario + DGI.
// Reemplaza las 3 páginas dispersas (/admin/finanzas, /reportes-contables, /dgi) y las 3 viejas redirigen acá.
// Soporta deep-link por query param: /admin/finanzas/reportes?tab=balance

import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import AdminLayout from '../../components/AdminLayout'

import { ContabilidadResumen, CSS as CSS_CB } from './Contabilidad'
import {
  TableroKPIs, BalanceGeneral, EstadoResultados, MayorCuenta, Diario,
  CSS as CSS_RC,
} from './ReportesContables'
import { Form1387, AnticipoIRAE, Form2181, CSS as CSS_DGI } from './ReportesDGI'

const TABS = [
  { key: 'resumen', label: '📊 Resumen del mes',      Comp: ContabilidadResumen },
  { key: 'kpis',    label: '🎯 KPIs',                  Comp: TableroKPIs },
  { key: 'balance', label: '📈 Balance General',       Comp: BalanceGeneral },
  { key: 'pyl',     label: '📉 Estado de Resultados',  Comp: EstadoResultados },
  { key: 'mayor',   label: '📒 Mayor por cuenta',      Comp: MayorCuenta },
  { key: 'diario',  label: '📋 Diario',                Comp: Diario },
  { key: 'dgi',     label: '🧮 DGI (IVA · IRAE · F2181)', Comp: DGITabs },
]

export default function ReportesHub() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [tab, setTab] = useState(searchParams.get('tab') || 'resumen')

  // Sync URL ↔ state. Cuando cambia tab, actualizo URL sin recargar.
  useEffect(() => {
    const fromUrl = searchParams.get('tab') || 'resumen'
    if (fromUrl !== tab) setTab(fromUrl)
  }, [searchParams])

  function changeTab(k) {
    setTab(k)
    setSearchParams({ tab: k }, { replace: true })
  }

  const Active = TABS.find(t => t.key === tab)?.Comp || ContabilidadResumen

  return (
    <AdminLayout>
      <div className="rh-wrap">
        <div className="rh-headline">
          <h1>Reportes contables</h1>
          <p>Toda la contabilidad de Limpack en un solo lugar: resumen del mes, KPIs, estados contables y declaraciones DGI.</p>
        </div>
        <div className="rh-tabs">
          {TABS.map(t => (
            <button
              key={t.key}
              className={tab === t.key ? 'active' : ''}
              onClick={() => changeTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div className="rh-body">
          <Active />
        </div>
      </div>
      <style>{CSS}</style>
      <style>{CSS_CB}</style>
      <style>{CSS_RC}</style>
      <style>{CSS_DGI}</style>
    </AdminLayout>
  )
}

// Sub-tabs del DGI: Form 1387 + Anticipo IRAE + Form 2181.
function DGITabs() {
  const [sub, setSub] = useState('iva')
  return (
    <div>
      <div className="rh-subtabs">
        <button className={sub === 'iva' ? 'active' : ''}    onClick={() => setSub('iva')}>📋 Form 1387 (IVA mensual)</button>
        <button className={sub === 'irae' ? 'active' : ''}   onClick={() => setSub('irae')}>📈 Anticipo IRAE</button>
        <button className={sub === 'f2181' ? 'active' : ''}  onClick={() => setSub('f2181')}>📑 Form 2181 (NO CEDE anual)</button>
      </div>
      {sub === 'iva' && <Form1387 />}
      {sub === 'irae' && <AnticipoIRAE />}
      {sub === 'f2181' && <Form2181 />}
    </div>
  )
}

const CSS = `
.rh-wrap { padding: 16px 20px 32px; max-width: 1400px; margin: 0 auto }
.rh-headline h1 { font-size: 26px; font-weight: 900; color: #1A3461; margin: 0 0 4px; letter-spacing: -.02em }
.rh-headline p { font-size: 13px; color: #64748b; margin: 0 0 16px }

.rh-tabs { display: flex; gap: 4px; border-bottom: 1px solid #e2e8f0; margin-bottom: 18px; flex-wrap: wrap; overflow-x: auto }
.rh-tabs button { background: transparent; border: 0; padding: 10px 14px; font-size: 13px; font-weight: 700; color: #64748b; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px; font-family: inherit; white-space: nowrap }
.rh-tabs button:hover { color: #1A3461; background: #f8fafc }
.rh-tabs button.active { color: #1A3461; border-bottom-color: #1A3461; background: #f1f5f9 }

.rh-subtabs { display: flex; gap: 4px; border-bottom: 1px solid #e2e8f0; margin-bottom: 14px; flex-wrap: wrap }
.rh-subtabs button { background: transparent; border: 0; padding: 8px 12px; font-size: 12.5px; font-weight: 700; color: #94a3b8; cursor: pointer; border-bottom: 2px solid transparent; margin-bottom: -1px; font-family: inherit }
.rh-subtabs button:hover { color: #1A3461 }
.rh-subtabs button.active { color: #0d9488; border-bottom-color: #0d9488 }

.rh-body { min-height: 200px }
`
